import {useContext, useEffect, useState} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import useMount from '@s-ui/react-hooks/lib/useMount/index.js'
import CardThirdPartyServices from '@adv-mt/mt-card-third-party-services'
import Check from '@adv-mt/mt-svg-icons/lib/Check'
import Financing from '@adv-mt/mt-svg-icons/lib/Financing'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import CardFinancingLendoModalContent from './card-financing-partner-motos-modal-content.js'

export default function CardFinancingLendo({adId, price}) {
  const [isModalOpen, setModalState] = useState(null)
  const [tracking, setTracking] = useState()
  const {track: analyticsTrack} = useAnalyticsTrack()

  const {domain, i18n} = useContext(Context)
  const urlStatics = domain.get('config').get('urlStatics')

  const iframe = `https://lendo.es/iframe?tracking_id=522&utm_source=Adevinta&utm_medium=Integration&utm_content=boton_iframe&utm_campaign=ADEVINTA_Motos_net_iframe&loan_amount=${price}`
  const lendoLogo = `${urlStatics}images/coches/transaction/lendo-logo.svg`

  const thirdPartyInfo = {
    title: i18n.t('FINANCE_CARD.PARTNER_LENDO.TITLE'),
    text: i18n.t('FINANCE_CARD.PARTNER_LENDO.TEXT'),
    buttonText: i18n.t('FINANCE_CARD.PARTNER_LENDO.BUTTON'),
    bottomText: (
      <div className="mt-CardFinancingLendo-bottomButtonText">
        <span className="mt-CardFinancingLendo-textItem">
          <Check />
          {i18n.t('FINANCE_CARD.PARTNER_LENDO.CLAIM_TEXT_1')}
        </span>
        <span className="mt-CardFinancingLendo-textItem">
          <Check />
          {i18n.t('FINANCE_CARD.PARTNER_LENDO.CLAIM_TEXT_2')}
        </span>
        <span className="mt-CardFinancingLendo-textItem">
          <Check />
          {i18n.t('FINANCE_CARD.PARTNER_LENDO.CLAIM_TEXT_3')}
        </span>
      </div>
    ),
    image: lendoLogo
  }

  const trackOpenModal = data => analyticsTrack({...data})

  useEffect(() => {
    isModalOpen && trackOpenModal(tracking)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen])

  const trackCloseModal = () =>
    analyticsTrack({
      event: 'Lendo Go Back Clicked'
    })

  const toggleModal = ({isOpen}) => {
    setModalState(isOpen)
    if (!isOpen) trackCloseModal()
  }

  const renderModalContent = <CardFinancingLendoModalContent urlIframeContent={iframe} />

  useMount(() => {
    const trackingProductsPromise = domain.get('get_advertisements_tracking_use_case').execute({
      ads: [adId],
      context: 'other'
    })

    const pageViewTrackingPromise = domain.get('get_page_tracking_data_use_case').execute({page: 'lendo'})
    Promise.all([pageViewTrackingPromise, trackingProductsPromise]).then(([{event, data}, {products}]) => {
      setTracking(() => {
        return {
          event,
          data: {
            ...data,
            products
          }
        }
      })
    })
  })

  return (
    <div className="mt-CardFinancingLendo">
      <CardThirdPartyServices modalCallback={toggleModal} buttonIcon={<Financing />} thirdPartyInfo={thirdPartyInfo}>
        {isModalOpen ? renderModalContent : null}
      </CardThirdPartyServices>
    </div>
  )
}

CardFinancingLendo.propTypes = {
  adId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  price: PropTypes.number.isRequired
}

CardFinancingLendo.displayName = 'CardFinancingLendo'
CardFinancingLendo.propTypes = {}
